import { render } from "./AjouterRoman.vue?vue&type=template&id=32a28a22"
import script from "./AjouterRoman.vue?vue&type=script&lang=js"
export * from "./AjouterRoman.vue?vue&type=script&lang=js"

import "./AjouterRoman.vue?vue&type=style&index=0&id=32a28a22&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__